import type { SVGProps } from "react";
const SvgCameraVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.5 21.5 4-4m2 0 4 4m-5-4v5"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M2 11.875c0-2.062 0-3.094 1.025-3.734S5.7 7.5 9 7.5h1c3.3 0 4.95 0 5.975.64C17 8.782 17 9.814 17 11.876v1.25c0 2.062 0 3.094-1.025 3.734S13.3 17.5 10 17.5H9c-3.3 0-4.95 0-5.975-.64C2 16.218 2 15.186 2 13.124z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m17 10.25.126-.076c2.116-1.27 3.174-1.904 4.024-1.598.85.307.85 1.323.85 3.355v1.138c0 2.032 0 3.048-.85 3.355s-1.908-.329-4.024-1.598L17 14.75"
    />
    <circle cx={12.5} cy={5} r={2.5} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={7} cy={4.5} r={3} stroke="currentColor" strokeWidth={1.5} />
  </svg>
);
export default SvgCameraVideo;
